import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from "@/components/ui/button";
import ProductionJobForm from '@/components/manufacturing/ProductionJobForm';
import ManufacturingService from '@/api/manufacturing.service';
import { useFormSubmission } from '@/hooks/use-api';
import LoadingSpinner from '@/components/shared/LoadingSpinner';

const CreateProductionJob: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const businessId = parseInt(localStorage.getItem('businessId') || '1');
  const prefilledData = location.state;

  const { handleSubmit, loading } = useFormSubmission(
    (data: any) => ManufacturingService.createProductionJob(businessId, data),
    {
      successMessage: "Production job created successfully",
      onSuccess: () => navigate('/manufacturing/production-jobs'),
      loadingKey: 'create-production-job'
    }
  );

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/manufacturing/production-jobs')}
          className="flex items-center gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Production Jobs
        </Button>
      </div>

      <div>
        <h1 className="text-3xl font-bold tracking-tight">Create Production Job</h1>
        <p className="text-muted-foreground">
          Create a new production job for manufacturing
        </p>
      </div>

      {loading ? (
        <LoadingSpinner message="Creating production job..." />
      ) : (
        <ProductionJobForm 
          initialData={prefilledData}
          onSubmit={(data) => handleSubmit(data)} 
          isLoading={loading} 
        />
      )}
    </div>
  );
};

export default CreateProductionJob; 